






















import Component from 'vue-class-component';
import Vue from 'vue';
import { Prop } from 'vue-property-decorator';
import InfoSvg from '@assets/svg/info.svg';
import IImage from '@frontend/types/base/IImage';
import ImageComponent from '@components/001-ImageComponent/ImageComponent.vue';

@Component({
	hydration: true,
	componentId: 'C015',
	components: {
		ImageComponent,
		InfoSvg
	}
})
export default class TooltipHint extends Vue {
	@Prop(String)
	protected readonly text!: string;

	@Prop({ type: String, default: null })
	protected readonly headline!: string | null;

	@Prop({ type: Object, default: null })
	protected readonly image!: IImage | null;

	protected tooltipContent: string | null = null;

	protected mounted(): void {
		this.tooltipContent = (this.$refs.tooltipContent as HTMLElement).innerHTML;
	}
}
